export default __webpack_public_path__ + "static/media/icono2gris.54acff59.svg";